import Vue from 'vue'
import { Component, Inject, Watch } from 'vue-property-decorator'
import { Form } from 'view-design'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import { Locale } from 'vant'

@Component({
	computed: { ...mapGetters(['userName']) },
})
export default class LayoutHeader extends Vue {
	@Inject('reload') public reload!: () => void
	showMobileMenu = false
	menus = []
	languages = [
		{
			label: 'English',
			value: 'en-us',
		},
		{
			label: '繁體中文',
			value: 'zh-tw',
		},
		{
			label: '简体中文',
			value: 'zh-cn',
		},
	]
	lang = this.$cookies.get('Language') || navigator.language.toLowerCase() || 'zh-tw'
	loginForm = {
		userId: '',
		password: '',
	}
	loginRule = {
		userId: [{ required: true, message: this.$t('請輸入學號'), trigger: 'blur' }],
		password: [
			{ required: true, message: this.$t('請輸入密碼'), trigger: 'blur' },
			{
				type: 'string',
				min: 6,
				message: this.$t('密碼長度不得少於6個字元'),
				trigger: 'blur',
			},
		],
	}
	loading = false
	isShowLoginCard: Boolean = false

	private mounted() {
		this.getMenu()
		this.setLogoutInterval()
	}

	get availableLanguages() {
		let currentLang = this.$i18n.locale || this.lang
		return this.languages.filter(lang => lang.value !== currentLang.toLowerCase())
	}

	get currentLanguage() {
		let currentLang = this.$i18n.locale || this.lang
		return this.languages.find(lang => lang.value === currentLang.toLowerCase())
	}

	@Watch('$store.state.isShowLoginMenu')
	watchIsShowLoginCard() {
		this.isShowLoginCard = this.$store.state.isShowLoginMenu
	}

	@Watch('$store.state.user.StudentBasicInfo')
	watchLoginEndTime() {
		this.setLogoutInterval()
	}

	get isLogin(): boolean {
		return this.$store.state.authenticated
	}

	private async getMenu() {
		try {
			let result = await this.$http.get('api/Menu')
			let data = JSON.parse(`${result.data}`)
			this.menus = data.root.function
		} catch (error) {
			console.log(error)
		}
	}

	private handleLanguage(langauge: string) {
		this.$i18n.locale = langauge
		//vant套件使用i18n
		Locale.use(langauge, this.$i18n.messages[langauge])
		this.$cookies.set('Language', langauge)
		this.reload()
	}

	private menuChange(name: string) {
		switch (name) {
			case 'logout':
				this.logout()
				break
			case 'login':
				this.isShowLoginCard = !this.isShowLoginCard
				break
			default:
				this.handleLanguage(name)
				break
		}
	}

	private async logout() {
		try {
			clearInterval(this.$store.state.logoutIntervalId)
			await this.$http.delete('api/Login')
			this.$store.dispatch('logout')
			this.$router.replace('/').catch((error: any) => error)
			this.$store.commit('setShowLoginMenu', true)
		} catch (err) {
			console.log(err)
		}
	}

	private getTarget(href: string) {
		if (href.indexOf('http') === 0) return '_blank'
		return '_self'
	}

	private setLogoutInterval() {
		if (!this.$store.state.user.StudentBasicInfo?.LoginEndTime) return
		clearInterval(this.$store.state.logoutIntervalId)
		let loginEndTime = DateTime.fromISO(this.$store.state.user.StudentBasicInfo.LoginEndTime).toUTC()
		var logoutInterval = setInterval(() => {
			var now = DateTime.local().toUTC()
			//比對開始跟now時間
			var timeDiff = loginEndTime.diff(now, ['hours', 'minutes', 'seconds']).toObject()
			//如果差異時間小於等於0則登出，並清除計時器
			if (timeDiff.seconds && timeDiff.seconds <= 0) {
				this.logout()
			}
		}, 500)
		this.$store.commit('setLogoutIntervalId', logoutInterval)
	}

	handleSubmit(name: string) {
		let form = this.$refs[name] as Form
		form.validate(async (valid: boolean | undefined) => {
			if (valid) {
				try {
					this.loading = true
					await this.$http.post('api/login', this.loginForm)
					await this.$store.dispatch('onLand')
					this.isShowLoginCard = false
					this.loginForm.userId = ''
					this.loginForm.password = ''
					this.$router.push('/CourseSelection').catch((error: any) => error)
					this.showMobileMenu = false
				} catch (error) {
					let errorMessage = _.get(error, 'data.Message', '學號或密碼錯誤')
					if (errorMessage == 'Maximum_Number_Of_People') {
						this.$Message.warning(this.$t(errorMessage))
					} else {
						this.$Message.error(this.$t(errorMessage))
					}
				} finally {
					this.loading = false
				}
			}
		})
	}
}
